import { configureStore } from "@reduxjs/toolkit";
import users from "./user/user-reducer";

export const store = configureStore({
  reducer: { users },
});
